import { FileInput, TFileWithType, TOption } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { useKycDocuments } from '@/features/kyc/hooks/useKycDocuments';
import { MAX_DOCUMENT_SIZE } from '@/features/kyc/constants';

interface IKycDocuments {
  handleFileChange: (files: TFileWithType[]) => void;
  defaultFiles?: TFileWithType[];
}

export function CreateUserKycDocuments({ handleFileChange, defaultFiles }: IKycDocuments) {
  const { t } = useTranslation();
  const { documentTypeOptions } = useKycDocuments();

  return (
    <FileInput
      onChangeFile={handleFileChange}
      defaultFilesValue={defaultFiles}
      direction="row"
      maxSize={MAX_DOCUMENT_SIZE}
      formats={['pdf', 'jpg', 'png']}
      isRequired
      documentTypeOptions={documentTypeOptions as TOption[]}
      hasSeveralDocuments
      tableLabel={{
        name: t('pages.dashboard.createUser.form.kycDocuments.name'),
        type: t('pages.dashboard.createUser.form.kycDocuments.type'),
      }}
      label={{
        main: t('pages.dashboard.createUser.form.kycDocuments.title'),
        browse: t('pages.dashboard.createUser.form.kycDocuments.browse'),
        format: t('pages.dashboard.createUser.form.kycDocuments.format'),
        maxSize: t('pages.dashboard.createUser.form.kycDocuments.maxSize'),
        update: t('pages.dashboard.createUser.form.kycDocuments.update'),
        delete: t('pages.dashboard.createUser.form.kycDocuments.delete'),
      }}
      otherActions={[
        {
          icon: 'open_in_new',
          onClick: (file: File) => window.open(URL.createObjectURL(file), '_blank'),
        },
      ]}
    />
  );
}
